import * as React from 'react';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import FaqIndividualDisplay from './FaqIndividualDisplay';
import { useFetch } from '../../hooks/useFetch';
import { getPropertyFaqsBySlug } from '../../api/PropertyFaqs';
import { LoadingDisplay } from '../common/LoadingOverlay';
import FormValidationDisplay from '../common/form/ValidationDisplay';
import { RouteComponentProps } from 'react-router-dom';
import { getPropertyByKey } from '../../api/Property';

export interface Props extends RouteComponentProps<{ propertySlug: string }> {}

const FaqPage = (props: Props) => {
    const backArrow = require('../../images/left-carot-small.png');

    const { data: faqs, loading: isLoadingFaqs, error: errorMessageFaqs } = useFetch(
        () => getPropertyFaqsBySlug(props.match.params.propertySlug),
        [],
        undefined
    );

    const {
        data: propertyInfo,
        loading: isLoadingPropertyInfo,
        error: errorMessagePropertyInfo
    } = useFetch(() => getPropertyByKey(props.match.params.propertySlug), [], undefined);

    let isLoading = isLoadingFaqs || isLoadingPropertyInfo;
    let errorMessage = errorMessageFaqs || errorMessagePropertyInfo;

    const filteredFaqs = faqs
        ? faqs.filter(f => f.questionText !== '' && f.answerText !== '')
        : undefined;

    let pairedFaqs = [];

    if (filteredFaqs) {
        let index = 0;

        for (index = 0; index < filteredFaqs.length; index += 2) {
            let pair = filteredFaqs.slice(index, index + 2);
            pairedFaqs.push(pair);
        }
    }

    if (isLoading) {
        return <LoadingDisplay />;
    }

    return (
        <div>
            <label className="faq-property-name">{propertyInfo && propertyInfo.name} / FAQs</label>
            <FormValidationDisplay errorMessage={errorMessage} />
            <div className="back-button">
                <img src={backArrow} />
                <button onClick={() => props.history.goBack()}>Back</button>
            </div>
            {pairedFaqs.length === 0 && (
                <div>This property doesn't currently have any FAQs set up.</div>
            )}
            {pairedFaqs.map(f => (
                <Row key={f[0].id}>
                    <Col xs={12} lg={6}>
                        <FaqIndividualDisplay faq={f[0]} key={f[0].id} />
                    </Col>
                    {f.length === 2 && (
                        <Col xs={12} lg={6}>
                            <FaqIndividualDisplay faq={f[1]} key={f[1].id} />
                        </Col>
                    )}
                </Row>
            ))}
        </div>
    );
};

export default FaqPage;



// WEBPACK FOOTER //
// ./src/components/pages/FaqPage.tsx